module.exports = __webpack_public_path__ + "img/cerf5.a9ae4bd0.jpg";